import {getPlaylistItemForDuration} from '../utils/duration';

export default {

    props: {
        setDuration: {
            type: Number,
            required: false,
        },

        maxDuration: {
            required: false,
            default: 0
        }
    },

    data() {
        return {
            setLocalDuration: null
        }
    },

    watch: {
        setDuration() {
            // No player or duration available
            if (!this.player || this.setDuration === null) {
                return;
            }

            // On nothing player we do not need to update the player
            const currentPlaylist = this.player.playlist();
            if (!this.src && !currentPlaylist.length) {
                return;
            }

            this.setLocalDuration = this.setDuration;

            console.log('Set video duration', this.setLocalDuration);

            // For normal player (without playlist) we can use the currentTime without any playlist calculations
            if (this.src || currentPlaylist.length === 1) {
                this.player.currentTime(this.setLocalDuration);

                if (this.playing) {
                    this.play();
                }
            } else {
                const playlistItem = getPlaylistItemForDuration(currentPlaylist, this.maxDuration, this.setDuration);

                // Change playlist index and set time
                this.player.playlist.currentItem(playlistItem.playlistItem.playlistItemId_ - 1);
                this.player.currentTime(this.setLocalDuration - playlistItem.offset);

                if (this.playing) {
                    this.play();
                }
                else{
                    this.player.pause();
                }
            }

            this.setLocalDuration = null;
        }
    }
}
